import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import i18n from 'i18n';
import { fetchPromocode, resetResult } from 'actions/promocode';
import { showModal, hideModal } from 'actions/modal';
import { resetAllDetailsData } from 'actions/details';
import { resetAllChannelsData } from 'actions/channels';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import { get } from 'lodash';
import BackButton from 'components/BackButton';

import PromocodeForm from './PromocodeForm';

import { getCodeSelector, getResultSelector } from 'reducers/promocode/selectors';
import { StyledBlock, StyledTitle } from '../../Auth/StyledComponents';
import { MODAL_TYPES } from 'constants/modal-types';

const i18nScope = 'profile.promocode';
const SECTION_NAME = 'promocode_INPUT';

const PromocodePage = (props) => {
  const {
    code,
    result,
    fetchPromocode,
    resetResult,
    resetAllChannelsData,
    resetAllDetailsData,
    history,
    showModal,
    hideModal,
  } = props;

  const onSubmit = useCallback(
    (value) => {
      fetchPromocode({ code: value });
    },
    [fetchPromocode],
  );

  useEffect(() => {
    if (!result) return;

    const closeModal = () => {
      hideModal();
      resetResult();
      SpatialNavigationWrapper.focus(SECTION_NAME);
    };

    const closeSuccessModal = () => {
      hideModal();
      resetResult();
      resetAllChannelsData();
      resetAllDetailsData();
      history.replace('/');
    };

    //дефолтный конфиг с ошибкой
    let modalConfig = {
      onModalBack: closeModal,
      title: i18n.t(`${i18nScope}.errorTitle`),
      description: get(result, 'error.message', i18n.t(`${i18nScope}.errorMessage`)),
      buttons: [
        {
          text: i18n.t(`${i18nScope}.errorButton`),
          handler: closeModal,
        },
      ],
      transparent: false,
    };

    if (result.data) {
      modalConfig = {
        onModalBack: closeSuccessModal,
        title: '',
        description: get(result, 'data.message', ''),
        buttons: [
          {
            text: i18n.t(`${i18nScope}.successButton`),
            handler: closeSuccessModal,
          },
        ],
        transparent: false,
      };
    }

    showModal(MODAL_TYPES.NOTIFICATION, modalConfig);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result]);

  useEffect(() => {
    if (!code) return;
    onSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <StyledBlock>
        <StyledTitle>{i18n.t(`${i18nScope}.title`)}</StyledTitle>
      </StyledBlock>
      <PromocodeForm
        initialValue={code}
        placeholder={i18n.t(`${i18nScope}.placeholder`)}
        invalidMessage={i18n.t(`${i18nScope}.invalidMessage`)}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

PromocodePage.defaultProps = {
  code: '',
  result: null,
};

PromocodePage.propTypes = {
  fetchPromocode: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  code: PropTypes.string,
  result: PropTypes.object,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  code: getCodeSelector,
  result: getResultSelector,
});

const mapDispatchToProps = {
  fetchPromocode,
  resetResult,
  showModal,
  hideModal,
  resetAllChannelsData,
  resetAllDetailsData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PromocodePage);
